import { useSecureGraphqlMutation } from '@psyomics/ui-common';

import {
  SubmitReferralRequestDocument,
  SubmitReferralRequestMutation,
  SubmitReferralRequestMutationVariables,
} from '../generated/referral-request';

const useSubmitReferralRequest = () => {
  const [{ data, fetching, errorMessage }, executeMutation] = useSecureGraphqlMutation<
    SubmitReferralRequestMutation,
    SubmitReferralRequestMutationVariables,
    'ReferralRequestNotReadyForSubmission'
  >(SubmitReferralRequestDocument, ['ReferralRequestNotReadyForSubmission' as const]);

  const submitReferralRequest = (id: string) => executeMutation({ id });

  return { errorMessage, fetching, submitted: data?.submitReferralRequest ?? false, submitReferralRequest };
};

export { useSubmitReferralRequest };
